import { render, staticRenderFns } from "./BasisEdit.vue?vue&type=template&id=d99361ec&scoped=true"
import script from "./BasisEdit.vue?vue&type=script&lang=js"
export * from "./BasisEdit.vue?vue&type=script&lang=js"
import style0 from "./BasisEdit.vue?vue&type=style&index=0&id=d99361ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99361ec",
  null
  
)

export default component.exports